document.addEventListener('DOMContentLoaded', () => {
  new window.Swiper('.swiper.how-it-works__steps-wrapper', {
    speed: 400,
    spaceBetween: 12,
    slidesPerView: 1.1,
    slidesPerGroup: 1,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    },
  });
});
